export default __webpack_public_path__ + "static/media/ava-director.c38667bc.png";